/**
 * Altar del Perfume — botón flotante de WhatsApp.
 *
 * En pantallas sin hover (celular) el botón se expande solo con «Contactar un asesor» después
 * de 20 s en la página, se queda 6 s y se recoge. Una sola vez por sesión: repetirlo en cada
 * página cansaría. En escritorio la etiqueta aparece con el cursor (CSS), así que aquí no se hace
 * nada.
 */
(() => {
  const btn = document.querySelector('[data-altar-wa]');
  if (!btn || window.matchMedia('(hover: hover)').matches) return;

  const KEY = 'altar-wa-nudge';
  try {
    if (sessionStorage.getItem(KEY)) return;
  } catch {}

  setTimeout(() => {
    btn.classList.add('is-open');
    try {
      sessionStorage.setItem(KEY, '1');
    } catch {}
    setTimeout(() => btn.classList.remove('is-open'), 6000);
  }, 20000);
})();
